import { render, staticRenderFns } from "./appDashboard.vue?vue&type=template&id=8573d38e&"
import script from "./appDashboard.vue?vue&type=script&lang=js&"
export * from "./appDashboard.vue?vue&type=script&lang=js&"
import style0 from "./appDashboard.vue?vue&type=style&index=0&id=8573d38e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports